
















import { Component, Vue, Prop, Emit } from 'vue-property-decorator'
import { jobDetailsLocalisationKeys } from '@/features/job/job.localisation'
import { IProcessingErrors } from '@/features/job/store'

@Component
export default class JobDetailsHeader extends Vue {
  private translations = jobDetailsLocalisationKeys

  @Prop()
  readonly processingErrors!: IProcessingErrors[]

  @Emit('removeJob')
  showRemoveDialog (): void {}
}
